import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import createRootReducer from './reducers/';
import { routerMiddleware } from 'connected-react-router';
import {verifyAuth} from './actions/UserAction'
import thunk from 'redux-thunk';
import { persistStore, persistReducer} from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

export const history = createBrowserHistory();

const initialState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: [
    'router',
    'formValues',
    'userState',
    'stepsSubmitted',
    'stepsClientSubmitted',
    'formValuesClient',
    'DeleteImageReducer',
    'messageState',
  ]
 };

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
const composedEnhancers = compose(
  applyMiddleware(...middleware),
  // DevTools.instrument()
  ...enhancers
);

const pReducer = persistReducer(persistConfig,  createRootReducer(history));
 
const store = createStore(pReducer,initialState,
  composedEnhancers);

store.dispatch(verifyAuth());

export const persistor =persistStore(store)
export default store;